import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: "FilterByKeys"
})
export class FilterByKeysPipe implements PipeTransform {
  transform(list: any[], keys?: any, value?: any): any {
    list = list.filter(element => {
      let listValues = [];
      for (let key of keys) {
        listValues.push(element[key].toLowerCase());
      }

      return (
        listValues.filter(x => x.indexOf(value.toLowerCase()) !== -1).length > 0
      );
    });

    return list;
  }
}



// WEBPACK FOOTER //
// ./src/app/pipes/filter-by-keys.pipe.ts